/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val, i = Math.floor(Math.abs(val)), v = val.toString().replace(/^[^.]*\.?/, '').length;

if (i === 1 && v === 0)
    return 1;
if (!(v === 0) || (n === 0 || !(n === 1) && (n % 100 === Math.floor(n % 100) && (n % 100 >= 1 && n % 100 <= 19))))
    return 3;
return 5;
}

export default ["ro",[["a.m.","p.m."]],u,[["D","L","M","M","J","V","S"],["dum.","lun.","mar.","mie.","joi","vin.","sÃ¢m."],["duminicÄ","luni","marÈi","miercuri","joi","vineri","sÃ¢mbÄtÄ"],["du.","lu.","ma.","mi.","joi","vi.","sÃ¢."]],u,[["I","F","M","A","M","I","I","A","S","O","N","D"],["ian.","feb.","mar.","apr.","mai","iun.","iul.","aug.","sept.","oct.","nov.","dec."],["ianuarie","februarie","martie","aprilie","mai","iunie","iulie","august","septembrie","octombrie","noiembrie","decembrie"]],u,[["Ã®.Hr.","d.Hr."],u,["Ã®nainte de Hristos","dupÄ Hristos"]],1,[6,0],["dd.MM.y","d MMM y","d MMMM y","EEEE, d MMMM y"],["HH:mm","HH:mm:ss","HH:mm:ss z","HH:mm:ss zzzz"],["{1}, {0}",u,u,u],[",",".",";","%","+","-","E","Ã","â°","â","NaN",":"],["#,##0.###","#,##0Â %","#,##0.00Â Â¤","#E0"],"RON",u,"leu romÃ¢nesc",{"AUD":[u,"$"],"BRL":[u,"R$"],"BYN":[u,"Ñ."],"CAD":[u,"$"],"CNY":[u,"Â¥"],"EUR":[u,"â¬"],"GBP":[u,"Â£"],"HKD":[u,"$"],"ILS":[u,"âª"],"INR":[u,"â¹"],"JPY":[u,"Â¥"],"KRW":[u,"â©"],"MXN":[u,"$"],"NZD":[u,"$"],"PHP":[u,"â±"],"TWD":[u,"NT$"],"USD":[u,"$"],"VND":[u,"â«"],"XCD":[u,"$"]},"ltr", plural];
